import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DataService } from '../../services/data/data.service';

@Component({
	selector: 'pcm-ui-date-time',
	templateUrl: './ui-date-time.component.html',
	styleUrls: ['./ui-date-time.component.scss']
})
export class UiDateTimeComponent implements OnInit {
	@Input() dateTime;

	@Output() dateTimeChanged: EventEmitter<any> = new EventEmitter();

	dateModel = {};
	constructor(
		private dataService: DataService
	) {}

	ngOnInit() {
		// need remove getDatepickerModel from calendar.service
		this.dateModel = this.dataService.getDatepickerModel(this.dateTime.date);
	}

	updateDate(event) {
		this.dateTime.date = this.dataService.formatPickerDate(this.dateModel);
	}
}
